import { render, staticRenderFns } from "./CardTitle.vue?vue&type=template&id=60d80ead&scoped=true"
import script from "./CardTitle.vue?vue&type=script&lang=js"
export * from "./CardTitle.vue?vue&type=script&lang=js"
import style0 from "./CardTitle.vue?vue&type=style&index=0&id=60d80ead&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d80ead",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60d80ead')) {
      api.createRecord('60d80ead', component.options)
    } else {
      api.reload('60d80ead', component.options)
    }
    module.hot.accept("./CardTitle.vue?vue&type=template&id=60d80ead&scoped=true", function () {
      api.rerender('60d80ead', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/home/components/CardTitle.vue"
export default component.exports